import { EMeasuringUnit } from "../interface/IUsage";
import { format } from "date-fns";
import { DATE_FORMAT } from "@constants";
import { IUsageSummaryList } from "../interface/IUsageSummary";

export interface IUsageSummaryResponse {
    eventCount: number;
    usageTypeName: string;
    usageType: string;
    amount: number;
    measuringUnit: EMeasuringUnit;
    quantity: number;
}

export interface IUsageSummaryListResponse {
    usageSummary: IUsageSummaryResponse[];
    billPeriodStartDate: string;
    billPeriodEndDate: string;
}

export const getResponseToState = (response: IUsageSummaryListResponse): IUsageSummaryList => ({
    usageSummary: response.usageSummary.map((usage) => ({
        amount: usage.amount,
        quantity: usage.quantity,
        measuringUnit: usage.measuringUnit,
        usageTypeName: usage.usageTypeName,
        eventCount: usage.eventCount,
        usageType: usage.usageType,
    })),
    billPeriodStartDate: format(new Date(response.billPeriodStartDate), DATE_FORMAT),
    billPeriodEndDate: format(new Date(response.billPeriodEndDate), DATE_FORMAT),
});
